import { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import styles from './CampaignCarousel.module.css';

/** 가로 스크롤 캐러셀. 데스크톱에서는 좌우 화살표, 모바일에서는 스와이프. */
export default function CampaignCarousel({ children }) {
  const trackRef = useRef(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(true);

  const sync = useCallback(() => {
    const el = trackRef.current;
    if (!el) return;
    const max = el.scrollWidth - el.clientWidth;
    setAtStart(el.scrollLeft <= 4);
    setAtEnd(el.scrollLeft >= max - 4);
  }, []);

  useEffect(() => {
    const el = trackRef.current;
    if (!el) return undefined;
    sync();
    el.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    return () => {
      el.removeEventListener('scroll', sync);
      window.removeEventListener('resize', sync);
    };
  }, [sync, children]);

  const step = (direction) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({ left: direction * Math.round(el.clientWidth * 0.8), behavior: 'smooth' });
  };

  return (
    <div className={styles.wrap}>
      <div className={styles.track} ref={trackRef}>
        {children}
      </div>

      {!atStart && (
        <button className={`${styles.arrow} ${styles.arrowPrev}`} onClick={() => step(-1)} aria-label="이전">
          <ChevronLeft size={20} strokeWidth={2.2} />
        </button>
      )}
      {!atEnd && (
        <button className={`${styles.arrow} ${styles.arrowNext}`} onClick={() => step(1)} aria-label="다음">
          <ChevronRight size={20} strokeWidth={2.2} />
        </button>
      )}
    </div>
  );
}
